import { defineStore } from "pinia";
import { ref } from "vue";
import { useBase, useServerPaginatedCollection } from "@/utils/stores/base";

const storeName = "saleListingAgreement";

export const useSaleListingAgreementStore = defineStore(storeName, () => {
  const all = ref([]);

  const searchQuery = ref(null);
  const filters = ref({});
  const {
    baseFetchOne,
    baseFetchPage,
    baseMultipartSave,
    basePost,
    baseDelete,
    watchRemoteResourceChange,
  } = useBase(storeName);

  const empty = {};

  const save = async (resource, callback, errorCallback) => {
    return await baseMultipartSave("sale-listing-agreements", resource, callback, errorCallback);
  };

  const {
    fetchAll,
    goToPage,
    goToNextPage,
    goToPreviousPage,
    currentPage,
    totalCount,
    totalPages,
    paginationRange,
  } = useServerPaginatedCollection({
    resources: all,
    itemsPerPage: 10,
    searchQuery,
    filters,
    fetchPage: async (errorCallback, includes, page, perPage, extraParams) => {
      return await baseFetchPage("sale-listing-agreements", errorCallback, includes, {
        page,
        perPage,
        extraParams,
      });
    },
  });

  const fetchOne = async (id, errorCallback, includes = []) => {
    return await baseFetchOne("sale-listing-agreements", id, errorCallback, includes);
  };

  const buildReport = async (saleListingAgreementId, callback, errorCallback, includes = []) => {
    const path = `sale-listing-agreements/${saleListingAgreementId}/reports/sale-listing-agreements`;
    const params = {};
    if (includes && includes.length > 0) {
      params.include = Array.isArray(includes) ? includes.join(",") : includes;
    }
    return await basePost(path, {}, callback, errorCallback, params);
  };

  const deleteReport = async (
    saleListingAgreementReportId,
    saleListingAgreementId,
    callback,
    errorCallback,
  ) => {
    const path = `sale-listing-agreements/${saleListingAgreementId}/reports/sale-listing-agreements`;
    return await baseDelete(path, saleListingAgreementReportId, callback, errorCallback);
  };

  const watchResourceChanges = async (callback) => {
    await watchRemoteResourceChange(storeName, callback);
  };

  return {
    all,
    currentPage,
    empty,
    fetchAll,
    fetchOne,
    goToNextPage,
    goToPage,
    goToPreviousPage,
    paginated: all,
    paginationRange,
    save,
    searchQuery,
    filters,
    sorted: all,
    totalCount,
    totalPages,
    buildReport,
    deleteReport,
    watchResourceChanges,
  };
});
